import * as url from "../../helpers/url_helper";
import { fetchApi } from "./apiService";
import { handleApiError } from "./helpers";

/**
 * Loads dashboard data and last installed stores
 * @param {Function} notifyError - Error notification function
 * @param {number} limit - Limit for last installed stores (default: 20)
 * @returns {Promise<Object|null>} Object with dashboard data and installed stores or null if error
 */
export const loadDashboardData = async (notifyError, limit = 20) => {
    try {
        const [dashboardResponse, lastInstalledStoresResponse] = await Promise.all([
            fetchApi(url.GET_DASHBOARD, 'GET'),
            fetchApi(`${url.GET_LAST_INSTALLED_STORES}?limit=${limit}`, 'GET')
        ]);

        const dashboard_data = dashboardResponse.results;
        const last_installed_stores = lastInstalledStoresResponse.results;

        // Handle dashboard response
        if (!dashboardResponse.response.ok) {
            handleApiError(dashboardResponse.response, dashboard_data, notifyError);
            return null;
        }

        // Handle last installed stores response
        if (!lastInstalledStoresResponse.response.ok) {
            handleApiError(lastInstalledStoresResponse.response, last_installed_stores, notifyError);
            return null;
        }

        return {
            dashboard: dashboard_data,
            lastInstalledStores: last_installed_stores?.data || []
        };
    } catch (err) {
        notifyError("Please check your network connection.");
        return null;
    }
};

